import { CommonSettingsProps } from 'approot/activity-builder/activity-builder.constants';
import {
  GetActivitiesSections_getActivitiesSections_components_ActivitiesResponseComponent_properties,
  GetActivitiesSections_getActivitiesSections_components_ActivitiesResponseComponent_properties_textResponse_fields,
} from 'approot/activity-builder/__generated__/GetActivitiesSections';
import { ComponentResponse } from '../component.constants';
import { ZoomComponentModalProps } from 'approot/activity-builder/activity-builder-zoom-component-modal.constants';
import {
  COLOUR_GREEN,
  COLOUR_RED,
} from 'approot/shared/colour/colour.constants';

export type ViewProps = Omit<ComponentResponse, '__typename'> &
  ZoomComponentModalProps;
export type SettingsProps = ViewProps & CommonSettingsProps;

export const typename = 'ActivitiesResponseComponent';
export type ResponseProperties = GetActivitiesSections_getActivitiesSections_components_ActivitiesResponseComponent_properties;

export const PRINT_LINE_HEIGHT = 72;

export type Field = GetActivitiesSections_getActivitiesSections_components_ActivitiesResponseComponent_properties_textResponse_fields;

export const COLOURS = [COLOUR_RED, COLOUR_GREEN];
